import { render, staticRenderFns } from "./CoursewareTabsContainer.vue?vue&type=template&id=2cf79e9c&"
import script from "./CoursewareTabsContainer.vue?vue&type=script&lang=js&"
export * from "./CoursewareTabsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf79e9c')) {
      api.createRecord('2cf79e9c', component.options)
    } else {
      api.reload('2cf79e9c', component.options)
    }
    module.hot.accept("./CoursewareTabsContainer.vue?vue&type=template&id=2cf79e9c&", function () {
      api.rerender('2cf79e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareTabsContainer.vue"
export default component.exports